var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8337 6.70833V3.56648C12.8337 3.10508 12.8337 2.87438 12.7204 2.63647C12.6558 2.50078 12.5088 2.31621 12.3909 2.22296C12.1843 2.05947 12.0119 2.01997 11.667 1.94098C11.1305 1.8181 10.5388 1.75 9.91699 1.75C8.7987 1.75 7.77764 1.97029 7.00033 2.33333C6.22301 2.69638 5.20195 2.91667 4.08366 2.91667C3.46187 2.91667 2.87014 2.84856 2.33366 2.72569C1.77368 2.59742 1.16699 2.992 1.16699 3.56648V9.85018C1.16699 10.3116 1.16699 10.5423 1.28023 10.7802C1.34481 10.9159 1.49189 11.1005 1.60973 11.1937C1.81636 11.3572 1.98879 11.3967 2.33366 11.4757C2.87014 11.5986 3.46187 11.6667 4.08366 11.6667C4.94048 11.6667 5.74023 11.5373 6.41699 11.3136",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16699 11.0833C8.16699 11.0833 8.75033 11.0833 9.33366 12.25C9.33366 12.25 11.1866 9.33333 12.8337 8.75",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45866 6.70833C8.45866 7.51375 7.80574 8.16667 7.00033 8.16667C6.19491 8.16667 5.54199 7.51375 5.54199 6.70833C5.54199 5.90292 6.19491 5.25 7.00033 5.25C7.80574 5.25 8.45866 5.90292 8.45866 6.70833Z",
    stroke: "#141B34",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20898 7.29163L3.20898 7.29687",
    stroke: "#141B34",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.792 6.12048L10.792 6.12572",
    stroke: "#141B34",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.03a0c3099b124b540458e1530b67dbb6.svg";
export { ForwardRef as ReactComponent };